module.exports = "/Muli-Regular.d80f1393f3ffecd0773bfee4aadfbf76.ttf";